import { render } from "./AddAccountValidationModal.vue?vue&type=template&id=3d47a3bc&ts=true"
import script from "./AddAccountValidationModal.vue?vue&type=script&lang=ts"
export * from "./AddAccountValidationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__